module.exports = __webpack_public_path__ + "static/tsn-grid-1-ae53de84fd59c68240b675b60341e35f.jpg";